import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../components/Icon'
import Reveal from '../components/Reveal'
import { Helmet } from 'react-helmet-async'

function About() {
  const navigate = useNavigate()
  useEffect(() => window.scrollTo(0, 0), [])

  return (
    <>
     <Helmet>
        <title>About Us | iLoveImgPdf</title>

        <meta
          name="description"
          content="iLoveImgPdf free online image & PDF tools. Compress, resize, crop, convert, merge, split, edit, sign and unlock your files right in the browser."
        />

        <meta
          name="keywords"
          content="Image,image tools, pdf tools, compress image, resize image, crop image, convert image, remove background, image to pdf, merge pdf, split pdf, compress pdf, pdf to word, word to pdf, pdf to excel, pdf to ppt, pdf to jpg, edit pdf, sign pdf, unlock pdf, protect pdf, rotate pdf, watermark pdf, free online tools"
        />

        <link
          rel="canonical"
          href="https://iloveimgpdf.com/about"
        />
      </Helmet>
    <main className="view">
      <div className="wrap subpage">
        {/* <div className="crumbs">
          <a onClick={() => navigate('/')}>Home</a>
          <Icon name="chevron-right" size={15} />
          <span className="here">About</span>
        </div> */}

        <Reveal className="about-top">
          <h1 >About iLoveImgPdf</h1>
          <p className="sub">Who we are &amp; what drives us</p>
        </Reveal>

        <div className="about-split">
          <Reveal className="about-visual">
            <span className="av-frame" />
            <span className="av-blob b1" />
            <span className="av-blob b2" />
            <div className="av-main mock">
              <div className="mock-bar"><i className="mdr" /><i className="mdy" /><i className="mdg" /></div>
              <div className="mock-body">
                <div className="m-search"><Icon name="search" size={12} style={{ color: '#9AA3B1' }} /><span className="sk" /></div>
                <div className="m-grid">
                  {['img', 'pdf', 'img', 'pdf', 'img', 'pdf'].map((k, i) => (
                    <div className="m-tile" key={i}>
                      <span className="m-chip" style={{ background: k === 'img' ? 'var(--img-tint)' : 'var(--pdf-tint)' }} />
                      <span className="sk" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="av-sub mock">
              <div className="mock-bar"><i className="mdr" /><i className="mdy" /><i className="mdg" /></div>
              <div className="mock-body">
                <div className="m-check"><Icon name="check" size={20} /></div>
                <div className="m-stats">
                  <div className="m-stat"><div className="v">2.4MB</div><div className="l">BEFORE</div></div>
                  <div className="m-stat"><div className="v g">0.6MB</div><div className="l">AFTER</div></div>
                  <div className="m-stat"><div className="v g">74%</div><div className="l">SAVED</div></div>
                </div>
                <div className="m-dl"><Icon name="download" size={12} />Download</div>
              </div>
            </div>
          </Reveal>

          <Reveal className="about-copy">
            <h2>One calm home for every file job</h2>
            <p>iLoveImgPdf brings the image and PDF tools you reach for every day into a single, friendly workspace fast, free, and private, with nothing to install.</p>
            <p>Most file tasks are small shrink a photo, merge a couple of PDFs, convert a file before you send it. Yet they often mean hunting for a website, dodging pop-ups, or installing software you only need once. We wanted those everyday jobs to feel calm and quick instead.</p>
            <p>So iLoveImgPdf puts a tidy set of image and PDF tools in one place, each one designed to do its job and get out of your way. No clutter, no upsells, no account walls.</p>
            <div className="about-actions">
              <button className="btn btn-c" onClick={() => navigate('/#tools')}>Explore the toolkit</button>
              <button className="btn btn-soft" onClick={() => navigate('/contact')}>Get in touch</button>
            </div>
          </Reveal>
        </div>

        <Reveal className="about-foot">
          <h3>Where we're headed</h3>
          <p>iLoveImgPdf is growing steadily. We add tools when they genuinely help, refine the ones we have, and keep the experience light. If there's something you wish iLoveImgPdf could do, we'd love to hear it.</p>
        </Reveal>
      </div>
    </main>
    </>
  )
}

export default About
